export enum ATTACHMENT_TYPES {
  RESUME = 1,
  COVER_LETTER = 2,
  SELECTION_CRITERIA = 4,
  HIRER_UPLOADED = 5,
}

export interface AttachmentType {
  type: ATTACHMENT_TYPES;
  typeName: AttachmentTypeName;
  displayName: string;
}

export type AttachmentTypeName =
  | 'resume'
  | 'cover letter'
  | 'selection criteria'
  | 'hirer uploaded';

export const RESUME: AttachmentType = {
  type: ATTACHMENT_TYPES.RESUME,
  typeName: 'resume',
  displayName: 'Resumé',
};
export const COVER_LETTER: AttachmentType = {
  type: ATTACHMENT_TYPES.COVER_LETTER,
  typeName: 'cover letter',
  displayName: 'Cover Letter',
};

export const SELECTION_CRITERIA: AttachmentType = {
  type: ATTACHMENT_TYPES.SELECTION_CRITERIA,
  typeName: 'selection criteria',
  displayName: 'Selection Criteria',
};

export const HIRER_UPLOADED: AttachmentType = {
  type: ATTACHMENT_TYPES.HIRER_UPLOADED,
  typeName: 'hirer uploaded',
  displayName: '',
};

export const TYPE_MAPPING = [
  RESUME,
  COVER_LETTER,
  SELECTION_CRITERIA,
  HIRER_UPLOADED,
];

export const getNameByType = (type: ATTACHMENT_TYPES) => {
  const typeObject = TYPE_MAPPING.find((t) => t.type === type);

  return typeObject ? typeObject.typeName : undefined;
};

export const getDisplayNameByType = (type: ATTACHMENT_TYPES) => {
  const typeObject = TYPE_MAPPING.find((t) => t.type === type);

  return typeObject ? typeObject.displayName : '';
};

export const isApplicationDocuments = (type: ATTACHMENT_TYPES): boolean =>
  [RESUME, COVER_LETTER, SELECTION_CRITERIA].some(
    (attachmentType) => attachmentType.type === type,
  );
